export default __webpack_public_path__ + "static/media/2412254.97c4cadf.webp";